module.exports = __webpack_public_path__ + "static/img/xiawucha@2x.cacd4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pc/xiawucha@2x.png
// module id = EnOt
// module chunks = 1